import en from './translations/en.json'
import fr from './translations/fr.json'

export default {
    en, fr
}